import styled from 'styled-components';
import { commonInputStyles } from '@vectorworks/vcs-ui/dist/lib/Input/Text/styles';

export const StyledEditor = styled.div`
    ${commonInputStyles}
    padding: 7px;
    box-sizing: content-box;
    overflow: auto;
`;
